import { render, staticRenderFns } from "./FolderEmailItem.vue?vue&type=template&id=f9d009fe&scoped=true"
import script from "./FolderEmailItem.vue?vue&type=script&lang=js"
export * from "./FolderEmailItem.vue?vue&type=script&lang=js"
import style0 from "./FolderEmailItem.vue?vue&type=style&index=0&id=f9d009fe&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f9d009fe",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
installComponents(component, {VBtn})
